import React, { useEffect } from 'react';
import { AddInboundItemSearchContent } from './add-inbound-item-search-content';
import { InboundReducerAction } from '@/hooks/use-order-inbound-reducer';
import { SCREEN_PADDING_LARGE, SCREEN_PADDING_XS } from '@/styles';
import {
  selectHasPendingItems,
  selectZeroQuantitySearchInputUUIDs,
  useOrderInboundDetailStore,
} from './store/order-inbound-detail-store';
import { StyleSheet, View } from 'react-native';
import { useShallow } from 'zustand/shallow';

interface Props {
  dispatch: React.Dispatch<InboundReducerAction>;
  onClose: (hasItems?: boolean) => void;
  smartOrderUUID: string;
}

export const AddItemInlinePanel: React.FC<Props> = ({
  dispatch,
  onClose,
  smartOrderUUID,
}) => {
  const setShowAddItemSheet = useOrderInboundDetailStore(
    (state) => state.actions.setShowAddItemSheet,
  );
  const clearPendingQuantityMap = useOrderInboundDetailStore(
    (state) => state.actions.clearPendingQuantityMap,
  );
  const hasPendingItems = useOrderInboundDetailStore(
    useShallow(selectHasPendingItems),
  );
  const zeroQuantitySearchInputUUIDs = useOrderInboundDetailStore(
    useShallow(selectZeroQuantitySearchInputUUIDs),
  );
  const handleClose = () => {
    setShowAddItemSheet(false);
    clearPendingQuantityMap();
    if (zeroQuantitySearchInputUUIDs.length > 0) {
      dispatch({
        payload: { searchInputUUIDs: zeroQuantitySearchInputUUIDs },
        type: 'REMOVE_ITEMS',
      });
    }
    onClose(hasPendingItems);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => () => clearPendingQuantityMap(), []);

  return (
    <View style={styles.inlineAddItemContainer} testID="add-item-inline-panel">
      <AddInboundItemSearchContent
        dispatch={dispatch}
        onClose={handleClose}
        smartOrderUUID={smartOrderUUID}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  inlineAddItemContainer: {
    flex: 1,
    paddingLeft: SCREEN_PADDING_XS,
    paddingTop: SCREEN_PADDING_LARGE,
  },
});
